module.exports = __webpack_public_path__ + "static/img/9.a66f7a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/zh/9.png
// module id = TN1B
// module chunks = 0